/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Composables
import { createVuetify } from 'vuetify';
import { VColorInput } from 'vuetify/labs/VColorInput';
import { VDateInput } from 'vuetify/labs/VDateInput';

export const colors = {
  primary: '#008080',
  secondary: '#5CBBF6',
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VColorInput,
    VDateInput,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors,
      },
    },
  },
});
